import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Define supported languages
const supportedLanguages = ['en', 'es', 'zh', 'ar', 'hi', 'fr', 'pt', 'de', 'it', 'uk'];

// Configure detection options to use only localStorage
const detectionOptions = {
  order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
  lookupQuerystring: 'lng', // ?lng=en
  lookupLocalStorage: 'i18nextLng',
  caches: ['localStorage'],
};

i18n
  // Load translations using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: 'en', // Default language
    supportedLngs: supportedLanguages,
    debug: process.env.NODE_ENV === 'development', // Enable debug in development

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Backend configuration
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // Path to translation files
      // Enable chunking for translation files to load them on demand
      allowMultiLoading: true,
      crossDomain: false,
    },

    // Detection options
    detection: detectionOptions,

    react: {
      useSuspense: true, // Use React Suspense for loading translations
    },

    // Load namespaces on demand
    ns: ['translation'],
    defaultNS: 'translation',
    partialBundledLanguages: true,

    // Only load the languages when needed
    load: 'languageOnly',
    preload: ['en'], // Only preload English as the fallback language
  });

export default i18n;
